import { render } from "./lacarte.vue?vue&type=template&id=392f1590&scoped=true"
import script from "./lacarte.vue?vue&type=script&lang=js"
export * from "./lacarte.vue?vue&type=script&lang=js"

import "./lacarte.vue?vue&type=style&index=0&id=392f1590&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-392f1590"]])

export default __exports__